import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=4a92ed0b&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=4a92ed0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92ed0b",
  null
  
)

export default component.exports